import React from "react";
import classNames from "classnames";

import { Pressable } from "../pressable";

import styles from "./styles.modules.scss";
import { useElementOnScreen } from "../../hooks/use-element-on-screen";

export const Button = ({
    animationSize,
    children,
    onClick,
    variant,
    size,
    disabled,
    className,
}: {
    animationSize?: "none" | "small" | "large";
    children: JSX.Element | JSX.Element[] | string;
    onClick: () => void;
    variant?: string;
    size?: string;
    disabled?: boolean;
    className?: string;
}) => {
    const [ref, isVisible] = useElementOnScreen<HTMLDivElement>();
    const [isExtraWide, setIsExtraWide] = React.useState(false);

    const button = (
        <button
            type="button"
            className={`container ${styles.container} `}
            disabled={disabled}
        >
            {children}
            <div className="button-shadow" />
        </button>
    );

    React.useEffect(() => {
        if (ref.current) {
            setIsExtraWide((ref.current?.textContent?.length ?? 0) > 16);
        }
    }, [ref]);

    return (
        <div
            ref={ref}
            className={classNames([
                className,
                "button",
                styles.button,
                variant,
                size,
                styles[variant ?? ""],
                {
                    visible: isVisible,
                    extrawide: isExtraWide,
                },
            ])}
            onClick={onClick}
        >
            {animationSize === "none" ? (
                button
            ) : (
                <Pressable animationSize={animationSize}>{button}</Pressable>
            )}
        </div>
    );
};
